import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import swal from "sweetalert";
import axios from "axios";
import Button from "@material-ui/core/Button";
import { updateStatus } from "../../utils/UpdateStatus";
import "../../modal.css";
import { api_path } from "../../shared";
function AddApproveModal(props) {
  const job_id=1;
  const [REMARK, SET_REMARK] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isReceiveButtonDisabled, setReceiveButtonDisabled] = useState(true);
  const [getOrderStatus, setOrderStatus] = useState([]);
  const [orderStatusList, setOrderStatusList] = useState([]);
  const [selectOrderStatus, setSelectOrderStatus] = useState([]);

  useEffect(() => {
    let order_status = props.STATUS;
    console.log("order_status " + order_status)
    if (order_status == "2") {//new
      setReceiveButtonDisabled(true);
    } else {
      setReceiveButtonDisabled(false);
    }
  },[]);
  useEffect(() => {
    fetchOrderStatus();

    setSelectOrderStatus(1);
    setOrderStatus({
      INQUIRY_MASTER_VALUE: 1,
      INQUIRY_MASTER_EN: "RECEIVE",
    });
 
  }, []);
  const fetchOrderStatus = () => {
    axios
      .get(api_path + `/MS_INQUIRY_MASTER.php?type=RECEIVE_CS`)
      .then((response) => {
        setOrderStatusList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleOrderStatusChange = (obj) => {
    setSelectOrderStatus(obj.INQUIRY_MASTER_VALUE);
    setOrderStatus({
      INQUIRY_MASTER_VALUE: obj.INQUIRY_MASTER_VALUE,
      INQUIRY_MASTER_EN: obj.INQUIRY_MASTER_EN,
    });
  };
const onSubmitForm = React.useCallback(({ STATUS }) => {
  const USER_ID = JSON.parse(localStorage.getItem("USER_ID")); // ← ดึงเองจาก localStorage

  swal({
    title: "Are you sure to send data?",
    icon: "info",
    dangerMode: false,
    buttons: true,
  }).then((isConfirm) => {
    if (isConfirm) {
      updateStatus({
        JOB_ID: props.ID,   // ← เปลี่ยนจาก job_id hardcode
        JOB_TYPE: props.TYPE ?? "CUSTOMER",
        STATUS: STATUS,
        REMARK: "",
        REASON_ID: "",
        REASON_NAME: "",
        USER_ID: USER_ID,   // ← เปลี่ยนจาก props.UserID
      });
    }
  });
}, [props.ID, props.TYPE]);
  return (
    <>
    
      <Button
        disabled={props.disabled} 
        type="button"
        fullWidth
        variant="contained"
        color="primary"
        onClick={() => onSubmitForm({ STATUS: 6 })}
      >
        Approve
      </Button>

      <Modal
        className="modal"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Review</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={(e) => {
              handleClose();
              e.preventDefault();
              updateStatus(props.ID, REMARK, props.USER_ID);
            }}
            id="editmodal"
            className=""
          >
            <input type="hidden" value={props.ID} />

            <label>
              REASON:
              <Select
                styles={{
                  menu: (provided) => ({ ...provided, zIndex: 9999 }),
                }}
                placeholder="Select..."
                value={getOrderStatus}
                options={orderStatusList}
                onChange={handleOrderStatusChange}
                getOptionLabel={(x) => x.INQUIRY_MASTER_EN}
                getOptionValue={(x) => x.INQUIRY_MASTER_VALUE}
                required
              />
            </label>
            <label>Remark:</label>
            <textarea
              id="txtArea"
              rows="3"
              cols="50"
              value={REMARK}
              onChange={(e) => SET_REMARK(e.target.value)}
              inputProps={{ maxLength: 250 }}
            ></textarea>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleClose}>
            Close
          </button>
          <button className="btn btn-primary" form="editmodal">
            Receive
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AddApproveModal;
